<template>
  <div class="container-fluid p-3">
    <div class="card">
      <div class="card-header">
        <h5 class="text-center">REPORTES POR EMPRESA</h5>
      </div>
      <div class="card-body">
        <div class="row">
          <!--Isquierda-->
          <div class="col-12 col-md-6">
            <div class="form-group">
              <label>Rubros:</label>
              <select
                class="form form-control"
                v-model="rubroBuscar"
                @change="getEmpresasByRubros(rubroBuscar)"
              >
                <option value="">SELLECIONAR</option>
                <option
                  v-for="(item, index) in rubros"
                  :key="index"
                  :value="item.id_rubro"
                  >{{ item.rubro_descripcion }}</option
                >
              </select>
            </div>
            <div
              class="table-responsive"
              style="overflow-y:scroll; height:360px;"
            >
              <table
                class="table table-striped table-bordered text-center"
                v-if="!cargando && empresas.length > 0"
              >
                <tr class="text-center">
                  <th><small class="font-weight-bold">NRO</small></th>
                  <th><small class="font-weight-bold">RAZÓN SOCIAL</small></th>
                  <th><small class="font-weight-bold">NIT</small></th>
                  <th><small class="font-weight-bold">ACCIÓN</small></th>
                </tr>

                <tr v-for="(item, index) in empresas" :key="index">
                  <td>
                    <small>{{ index + 1 }}</small>
                  </td>
                  <td>
                    <small>{{ item.emp_razon_social }}</small>
                  </td>
                  <td>
                    <small>{{ item.emp_nit }}</small>
                  </td>
                  <td class="text-center">
                    <a
                      class="btn btn-outline-info btn-sm"
                      @click="registrarParte(item)"
                      title="Mas Detalles"
                    >
                      <i class="fa fa-chevron-right"></i>
                    </a>
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <!--Derecha-->
          <div class="col-12 col-md-6">
            <h6 class="text-center">Detalle de Partes</h6>
            <h6 class="text-left">
              Empresa: <small>{{ empresaElegida.emp_razon_social }}</small>
            </h6>
            <h6 class="text-left">
              Rubro: <small>{{ empresaElegida.rubro_descripcion }}</small>
            </h6>
        <div class="row" v-if="empresaElegida.id_rubro == 1">
         <div class="col-lg-4">
            <div class="form-group">
              <label>Fecha Inicio:</label>
              <input
                type="date"
                v-model="fecha_inicio"
                class="form form-control"
              />
            </div>
          </div>
          <div class="col-lg-4">
            <div class="form-group">
              <label>Fecha Fin:</label>
              <input
                type="date"
                v-model="fecha_fin"
                class="form form-control"
              />
            </div>
          </div>
          <div class="col-lg-4">
           
            <div class="form-group pt-4">
              <button
                class="btn btn-info"
                type="button"
                @click="
                  buscarVuelo(
                    fecha_inicio,fecha_fin
                  )
                "
              >
                buscar
                <i class="fa fa-search"></i>
              </button>
            </div>
            </div>
            </div>
            <div
              class="table-responsive mt-3"
              style="overflow-y:scroll; height:360px;"
            >
              <table
                class="table table-striped table-bordered"
                v-if="empresaElegida.id_rubro == 1"
              >
                <tr class="text-center">
                  <th><small class="font-weight-bold">NRO</small></th>
                  <th>
                    <small class="font-weight-bold">FECHA REGISTRO</small>
                  </th>
                  <th><small class="font-weight-bold">DATOS</small></th>
                  <th><small class="font-weight-bold">TOTAL</small></th>
                  <th><small class="font-weight-bold">ACCIONES</small></th>
                </tr>
                <tr v-for="(item, index) in partesEmpresa" :key="index">
                  <!--1-->
                  <td class="text-center">
                    <small>{{ index + 1 }}</small>
                  </td>
                  <!--2-->
                  <td class="text-center">
                    <small>{{ getDateHora(item.fecha_reg) }}</small>
                  </td>
                  <!--3-->
                  <td>
                    <small>{{ "Tipo Vuelo: " + item.tipo_vuelo }}</small
                    ><br />
                    <small>{{ "Nro Vuelo: " + item.nro_vuelo }}</small>
                  </td>
                  <!--4-->
                  <td class="text-center">
                    <small>{{ item.totalregistros }}</small>
                  </td>
                  <!--5-->
                  <td class="text-center">
                    <a
                      class="btn btn-outline-primary btn-sm mr-1"
                      @click="showModal(1, item)"
                    >
                      <i class="fa fa-search"></i>
                    </a>
                    <a
                      class="btn btn-outline-success btn-sm"
                      title="Descargar Manifiesto"
                      @click="exportarXls(1, item)"
                    >
                      <i class="fa fa-download"></i>
                    </a>
                  </td>
                </tr>
              </table>

              <table
                class="table table-striped table-bordered"
                v-if="empresaElegida.id_rubro == 2"
              >
                <tr class="text-center">
                  <th><small class="font-weight-bold">NRO</small></th>
                  <th>
                    <small class="font-weight-bold">FECHA REGISTRO</small>
                  </th>
                  <th><small class="font-weight-bold">DATOS</small></th>
                  <th><small class="font-weight-bold">TOTAL</small></th>
                  <th><small class="font-weight-bold">ACCIONES</small></th>
                </tr>
                <tr v-for="(item, index) in partesEmpresa" :key="index">
                  <!--1-->
                  <td class="text-center">
                    <small>{{ index + 1 }}</small>
                  </td>
                  <!--2-->
                  <td class="text-center">
                    <small>{{ getDate(item.fecha_reg) }}</small>
                  </td>
                  <!--3-->
                  <td>
                    <small>{{ "Placa: " + item.placa }}</small
                    ><br />
                    <small>{{ "N° de Bus: " + item.numero_bus }}</small>
                  </td>
                  <!--4-->
                  <td class="text-center">
                    <small>{{ item.totalregistros }}</small>
                  </td>
                  <!--5-->
                  <td class="text-center">
                    <a
                      class="btn btn-outline-primary btn-sm mr-1"
                      @click="showModal(2, item)"
                      ><i class="fa fa-search"></i>
                    </a>
                    <a
                      class="btn btn-outline-success btn-sm"
                      title="Descargar Parte"
                      @click="exportarXls(2, item)"
                    >
                      <i class="fa fa-download"></i>
                    </a>
                  </td>
                </tr>
              </table>

              <table
                class="table table-striped table-bordered"
                v-if="empresaElegida.id_rubro == 3"
              >
                <tr class="text-center">
                  <th><small class="font-weight-bold">NRO</small></th>
                  <th>
                    <small class="font-weight-bold">FECHA REGISTRO</small>
                  </th>
                  <th><small class="font-weight-bold">FECHAS</small></th>

                  <th><small class="font-weight-bold">ACCIONES</small></th>
                </tr>
                <tr v-for="(item, index) in partesEmpresa" :key="index">
                  <!--1-->
                  <td class="text-center">
                    <small>{{ index + 1 }}</small>
                  </td>
                  <!--2-->
                  <td class="text-center">
                    <small>{{ item.fecha_reg }}</small>
                  </td>
                  <!--3-->
                  <td>
                    <small>{{ "Ingreso: " + item.fecha_inicio }}</small
                    ><br />
                    <small>{{ "Salida: " + item.fecha_fin }}</small>
                  </td>
                  <!--4-->

                  <!--5-->
                  <td class="text-center">
                    <a
                      class="btn btn-outline-primary btn-sm mr-1"
                      @click="showModal(3, item)"
                      ><i class="fa fa-search"></i>
                    </a>
                    <a
                      class="btn btn-outline-success btn-sm"
                      title="Descargar Parte"
                      @click="exportarXls(3, item)"
                    >
                      <i class="fa fa-download"></i>
                    </a>
                  </td>
                </tr>
              </table>

              <table
                class="table table-striped table-bordered"
                v-if="empresaElegida.id_rubro == 4"
              >
                <tr class="text-center">
                  <th><small class="font-weight-bold">NRO</small></th>
                  <th>
                    <small class="font-weight-bold">FECHA REGISTRO</small>
                  </th>
                  <th><small class="font-weight-bold">DATOS</small></th>
                  <th><small class="font-weight-bold">TOTAL</small></th>
                  <th><small class="font-weight-bold">ACCIONES</small></th>
                </tr>
                <tr v-for="(item, index) in partesEmpresa" :key="index">
                  <!--1-->
                  <td class="text-center">
                    <small>{{ index + 1 }}</small>
                  </td>
                  <!--2-->
                  <td class="text-center">
                    <small>{{ item.fecha_reg }}</small>
                  </td>
                  <!--3-->
                  <td>
                    <small>{{ "Fecha inicio: " + item.fecha_inicio }}</small
                    ><br />
                    <small>{{ "Fecha fin: " + item.fecha_fin }}</small>
                  </td>
                  <!--4-->
                  <td class="text-center">
                    <small>{{ item.totalregistros }}</small>
                  </td>
                  <!--5-->
                  <td class="text-center">
                    <a
                      class="btn btn-outline-primary btn-sm mr-1"
                      @click="showModal(4, item)"
                    >
                      <i class="fa fa-search"></i>
                    </a>
                    <a
                      class="btn btn-outline-success btn-sm"
                      title="Descargar Manifiesto"
                      @click="exportarXls(4, item)"
                    >
                      <i class="fa fa-download"></i>
                    </a>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      class="modal fade"
      size="xl"
      hide-footer
      title="DETALLE DE PARTES"
      ref="modalDetalles"
      :no-close-on-backdrop="true"
    >
      <div class="container mb-3">
        <div class="row mb-1">
          <div class="col-md-12">
            <p class="font-weight-bold">
              RAZON SOCIAL: "{{ empresaElegida.emp_razon_social }}"
            </p>
            <p class="font-weight-bold">
              RUBRO: "{{ empresaElegida.rubro_descripcion }}"
            </p>
            <p class="font-weight-bold" v-if="elegido.id_rubro == 3">
              DETALLE DE PARTE REGISTRADO (Del: {{ elegido.fecha_inicio }} al
              {{ elegido.fecha_fin }})
            </p>
          </div>
          <div
            class="table-responsive"
            style="overflow-y:scroll; height:360px;"
            v-if="detalles.length > 0"
          >
            <table
              class="table table-striped table-bordered text-center"
              v-if="empresaElegida.id_rubro == 1"
            >
              <thead>
                <tr>
                  <th><small class="font-weight-bold">NRO</small></th>
                  <th>
                    <small class="font-weight-bold">NOMBRE COMPLETO</small>
                  </th>
                  <th>
                    <small class="font-weight-bold">NRO. DOCUMENTO</small>
                  </th>
                  <th><small class="font-weight-bold">NACIONALIDAD</small></th>
                  <th>
                    <small class="font-weight-bold">ORIGEN/DESTINO</small>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in detalles" :key="index">
                  <td>
                    <small>{{ index + 1 }}</small>
                  </td>
                  <td>
                    <small>{{ item.nombre_completo }}</small>
                  </td>
                  <td>
                    <small>{{ item.nro_documento }}</small>
                  </td>
                  <td>
                    <small>{{ item.nacionalidad }}</small>
                  </td>
                  <td>
                    <small>{{ item.origen + "/" + item.destino }}</small>
                  </td>
                </tr>
              </tbody>
            </table>

            <table
              class="table table-bordered text-center"
              v-if="empresaElegida.id_rubro == 2"
            >
              <thead>
                <tr>
                  <th><small class="font-weight-bold">NRO</small></th>
                  <th>
                    <small class="font-weight-bold">NOMBRE COMPLETO</small>
                  </th>
                  <th>
                    <small class="font-weight-bold">NRO. DOCUMENTO</small>
                  </th>
                  <th><small class="font-weight-bold">NACIONALIDAD</small></th>
                  <th>
                    <small class="font-weight-bold">ORIGEN/DESTINO</small>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in detalles" :key="index">
                  <td>
                    <small>{{ index + 1 }}</small>
                  </td>
                  <td>
                    <small>{{ item.nombres }} {{ item.apellidos }}</small>
                  </td>
                  <td>
                    <small>{{ item.nro_documento }}</small>
                  </td>
                  <td>
                    <small>{{ item.nacionalidad }}</small>
                  </td>
                  <td>
                    <small>{{ item.origen + "/" + item.destino }}</small>
                  </td>
                </tr>
              </tbody>
            </table>

            <table
              class="table table-bordered"
              v-if="empresaElegida.id_rubro == 3"
            >
              <thead>
                <tr>
                  <th><small class="font-weight-bold">NRO</small></th>
                  <th>
                    <small class="font-weight-bold">NOMBRE COMPLETO</small>
                  </th>
                  <th>
                    <small class="font-weight-bold">NRO. DOCUMENTO</small>
                  </th>
                  <th><small class="font-weight-bold">FECHA INGRESO</small></th>
                  <th><small class="font-weight-bold">FECHA SALIDA</small></th>
                  <th><small class="font-weight-bold">NACIONALIDAD</small></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in detalles" :key="index">
                  <td>
                    <small>{{ index + 1 }}</small>
                  </td>
                  <td>
                    <small
                      >{{ item.per_nombres }} {{ item.per_primer_apellido }}
                      {{ item.per_segundo_apellido }}
                      {{ item.per_otro_apellido }}</small
                    >
                  </td>
                  <td>
                    <small>{{ item.per_numero_documento }}</small>
                  </td>
                  <td>
                    <small>{{ getDate(item.fecha_inicio) }}</small>
                  </td>
                  <td>
                    <small>{{ getDate(item.fecha_fin) }}</small>
                  </td>
                  <td>
                    <small>{{ item.nombre }}</small>
                  </td>
                </tr>
              </tbody>
            </table>

            <table
              class="table table-bordered text-center"
              v-if="empresaElegida.id_rubro == 4"
            >
              <thead>
                <tr>
                  <th><small class="font-weight-bold">NRO</small></th>
                  <th>
                    <small class="font-weight-bold">NOMBRE COMPLETO</small>
                  </th>
                  <th>
                    <small class="font-weight-bold">NRO. DOCUMENTO</small>
                  </th>
                  <th><small class="font-weight-bold">NACIONALIDAD</small></th>
                  <th>
                    <small class="font-weight-bold">ORIGEN/DESTINO</small>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in detalles" :key="index">
                  <td>
                    <small>{{ index + 1 }}</small>
                  </td>
                  <td>
                    <small>{{ item.nombre_completo }}</small>
                  </td>
                  <td>
                    <small>{{ item.nro_documento }}</small>
                  </td>
                  <td>
                    <small>{{ item.nacionalidad }}</small>
                  </td>
                  <td>
                    <small>{{ item.origen + "/" + item.destino }}</small>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="row float-right">
          <a class="btn btn-outline-secondary" @click="hideModal">Cerrar</a>
        </div>
      </div>
    </b-modal>

    <Loading v-show="cargando" />
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import Loading from "../../components/Loading";
import moment from "moment";

export default {
  name: "buscarEmpresas",
  components: {
    Loading,
  },
  data() {
    return {
      fecha_inicio: new moment().format("YYYY-MM-DD"),
      fecha_fin: new moment().format("YYYY-MM-DD"),
      empresaElegida: {},
      partesEmpresa: [],
     
      registros: [],
      detalles: [],
      id_empresa: 0,
      empresas: [],
      elegido: {},
      rubroBuscar: "",
      empresa: {
        //departamento: 'LPG',
        emp_latitud: 0,
        emp_longitud: 0,
      },
      cargando: false,
      tituloModal: "Registro Empresa",
      departamentos: [],
      imagen: {
        base64: "",
        content: "",
      },
      municipios: [],
      rubros: [],
      persona: {},
      controBoton: true,
      departamento: "",
      //submitted: false,
    };
  },
  methods: {
    showModal(rubro, item) {
      this.elegido = item;
      switch (rubro) {
        case 1:
          this.detallePartesAereo(item.id_aereo);
          this.$refs["modalDetalles"].show();
          break;
        case 2:
          this.detallePartesTerrestre(item.id_terrestre);
          this.$refs["modalDetalles"].show();
          break;
        case 3:
          this.detallePartesChek(item.id_empresa, item.id_parte);
          this.$refs["modalDetalles"].show();
          break;
        case 4:
          this.detallePartesAgencia(item.id_agencia);
          this.$refs["modalDetalles"].show();
          break;
      }
    },
    hideModal() {
      this.$refs["modalDetalles"].hide();
    },

    async registrarParte(empresa) {
      this.cargando = true;
      this.empresaElegida = empresa;
      let ruta = `/empresa/partesEmpresaAnalista/${empresa.id_empresa}`;
      switch (empresa.id_rubro) {
        case "1":
          ruta = `/empresa/partesEmpresaAerea/${empresa.id_empresa}`;
          break;
        case "2":
          ruta = `/empresa/partesTerrestresEmpresa/${empresa.id_empresa}`;
          break;
        case "3":
          ruta = `/empresa/partesHospedajeEmpresa/${empresa.id_empresa}`;
          break;
        case "4":
          ruta = `/empresa/partesAgenciaEmpresa/${empresa.id_empresa}`;
          break;
      }

      try {
        let res = await this.axios.get(ruta);
        this.cargando = false;
        if (res.status == 200) {
          this.partesEmpresa = res.data.contenido;
        }
      } catch (error) {
        this.cargando = false;
      }
    },

    async getEmpresasByRubros(rubroBuscar) {
      this.registros = [];
      try {
        let resultados = await this.axios.get(
          `/empresasReporteAnalista/${rubroBuscar}`
        );
        this.empresas = resultados.data.contenido;
      } catch (error) {
        console.log("catch: ", error);
      }
    },
    async buscarVuelo(fecha_inicio,fecha_fin) {
      this.registros = [];
      try {
        let resultados = await this.axios.get(
          `/buscarVuelos/${fecha_inicio}/${fecha_fin}`
        );
        this.partesEmpresa = resultados.data.contenido;
       
      } catch (error) {
        console.log("catch: ", error);
      }
    },
    // modal detalle
    async detallePartesChek(id_empresa, id_parte) {
      this.cargando = true;
      try {
        let res = await this.axios.get(
          `/historialParteEmpresa/detalle/${id_empresa}/${id_parte}`
        );
        this.detalles = res.data.contenido;
        this.cargando = false;
      } catch (error) {
        console.log("error ", error);
        this.cargando = false;
      }
    },
    async getDepartamentos() {
      try {
        let resultados = await this.axios.get(`/getDepartamentos`);
        this.departamentos = resultados.data.contenido;
      } catch (error) {
        console.log("catch: ", error);
      }
    },

    async getRubros() {
      try {
        let resultados = await this.axios.get(`/getRubros`);
        this.rubros = resultados.data.contenido;
      } catch (error) {
        console.log("catch: ", error);
      }
    },

    crearDescarga(response, title) {
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: "blob" })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", title);
      document.body.appendChild(link);
      link.click();
    },
    async exportarXls(rubro, empresa) {
      let config = { headers: { token: this.token }, responseType: "blob" };
      this.cargando = true;

      let fecha = empresa.fecha_reg;
      let fecha_ini = empresa.fecha_inicio;
      let fecha_sal = empresa.fecha_fin;
      fecha = moment(fecha).format("DD-MM-YYYY HH:mm:ss");
      fecha_ini = moment(fecha_ini).format("DD-MM-YYYY HH:mm:ss");
      fecha_sal = moment(fecha_sal).format("DD-MM-YYYY HH:mm:ss");
      try {
        switch (rubro) {
          case 1:
            this.resultados = await this.axios.get(
              `/reporteEmpresaAereaParte_xls/${empresa.id_aereo}/${empresa.tipo_vuelo}/${empresa.nro_vuelo}/${fecha}`,
              config
            );
            break;
          case 2:
            this.resultados = await this.axios.get(
              `/reporteEmpresaTerrestreParte_xls/${empresa.id_terrestre}/${empresa.placa}/${empresa.numero_bus}/${fecha}`,
              config
            );
            break;
          case 3:
            this.resultados = await this.axios.get(
              `/reporteEmpresa_xls/${empresa.id_empresa}/${empresa.id_parte}/${fecha_ini}/${fecha_sal}`,
              config
            );
            break;
          case 4:
            this.resultados = await this.axios.get(
              `/reporteEmpresaAgenciaParte_xls/${empresa.id_agencia}/${fecha_ini}/${fecha_sal}/${fecha}`,
              config
            );
            break;
        }

        await this.crearDescarga(this.resultados, "reporte.xlsx");

        // this.registros = this.resultados.data.contenido;
        this.cargando = false;
      } catch (error) {
        console.log(error);
        this.cargando = false;
      }
    },

    getDate: function(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    getDateHora: function(date) {
      return moment(date).format("YYYY-MM-DD HH:mm:ss");
    },
    formatFecha(event) {
      let str = event;
      let arrayFecha = str.split("/");
      return arrayFecha[2] + "-" + arrayFecha[1] + "-" + arrayFecha[0];
    },
    async listarDato() {
      let config = { headers: { token: this.token } };
      try {
        this.resultados = await this.axios.get(`/personaGetDataLogin`, config);
        this.persona = this.resultados.data.contenido;
        

        //this.getEmpresas(this.persona.id_persona);
      } catch (error) {
        console.log("catch: ", error);
      }
    },
    async detallePartesAereo(id) {
      this.cargando = true;
      try {
        let res = await this.axios.get(`/historial/detalleAereo/${id}`);
        this.detalles = res.data.contenido;
        this.cargando = false;
      } catch (error) {
        console.log("error ", error);
        this.cargando = false;
      }
    },
    async detallePartesTerrestre(id) {
      this.cargando = true;
      try {
        let res = await this.axios.get(`/historialTerrestres/detalle/${id}`);
        this.detalles = res.data.contenido;
        this.cargando = false;
      } catch (error) {
        console.log("error ", error);
        this.cargando = false;
      }
    },
    async detallePartesAgencia(id) {
      this.cargando = true;
      try {
        let res = await this.axios.get(`/historial/detalleAgencia/${id}`);
        this.detalles = res.data.contenido;
        this.cargando = false;
      } catch (error) {
        console.log("error ", error);
        this.cargando = false;
      }
    },
  },
  created() {
    this.listarDato();
    this.getDepartamentos();
    this.getRubros();
  },
  validations: {
    empresa: {
      emp_razon_social: { required },
      emp_nit: { required },
      emp_licencia: { required },
      emp_telefono: { required },
      codigo_departamento: { required },
      id_municipio: { required },
      emp_direccion: { required },
      id_rubro: { required },
      tipo_servicio: { required },
      emp_latitud: { required },
      emp_longitud: { required },
    },
  },
};
</script>
